import { FC, ReactNode } from 'react';
import cx from 'classnames';
import { AppLoader } from '../../components/app-loader';
import { AppStore, DataStore } from '../../store';
import { AppContainer, BaseComponentProps } from 'common';

interface LayoutProps extends BaseComponentProps {
  header?: string | ReactNode;
  containerWidth?: string;
}

export const SettingsLayout: FC<LayoutProps> = ({
  children,
  header,
  containerWidth = 'max-w-full md:max-w-2xl lg:max-w-4xl xl:max-w-4xl 2xl:max-w-6xl',
}) => {
  // TODO(Hadrien): for future improvement, busy should probably come from each route and not from the root component
  const busy = DataStore.useStoreState(s => s.busy);
  const dashboardSelectedDialogType = AppStore.useStoreState(
    s => s.dashboardSelectedDialogType
  );

  return (
    <>
      {busy && !dashboardSelectedDialogType && (
        <AppLoader isFixed spinnerTop="104px" />
      )}

      <AppContainer wrapperCls="p-6" cls="" containerWidth="xl" fullHeight>
        <div className="flex flex-col lg:flex-row">
          <div
            className={cx(
              containerWidth,
              'm-auto flex-1 h-fit bg-white border border-grey-bright rounded-4'
            )}
          >
            {header && (
              <>
                <div className="flex flex-col justify-center">
                  <div className="font-bold typo-20 p-6">{header}</div>
                </div>
                <hr className="bg-grey-bright" />
              </>
            )}
            <div>{children}</div>
          </div>
        </div>
      </AppContainer>
    </>
  );
};
